import { defineComponent as _defineComponent } from 'vue'
import VModal from "@/components/vModal.vue";

type vUpsellModalProps = {
  showModal: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'vUpsellModal',
  props: {
    showModal: { type: Boolean, default: false }
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as { showModal: boolean };





return { __sfc: true,props, emit, VModal }
}

})